import { useState, useCallback } from 'react';
import { timelineUseCases } from '../libs/timeline-services';
import type { RecentFileEntry } from './recent-files';

export const useRecentFiles = () => {
  const [files, setFiles] = useState<RecentFileEntry[]>(() => timelineUseCases.getRecentFiles());

  const refresh = useCallback(() => {
    setFiles(timelineUseCases.getRecentFiles());
  }, []);

  const remove = useCallback((fileName: string) => {
    timelineUseCases.removeRecentFile(fileName);
    setFiles(timelineUseCases.getRecentFiles());
  }, []);

  return { files, refresh, remove };
};
